import React, { useEffect } from "react";
import StyleWrapper from "./style";
import { InputSwitch } from "primereact/inputswitch";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { useState } from "react";
import propTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { BUSINESS_LINE_COLORS } from "helpers/utils";

const FeatureCard = (props) => {
  const bsfFreeGCCFeautureItemBool = Boolean(props.businessLine === "bsf") && Boolean(props.featureGroupName === "Feature - Geographical Extension")
  const bsfFreeMechanicalBreakdownFeautureItemBool = Boolean(props.selectedProposal === 'PRMotorImtiazeSP') && Boolean(props.businessLine === "bsf") && Boolean(props.featureGroupName === "Mechanical Breakdown")
  const [active, setActive] = useState(bsfFreeGCCFeautureItemBool || bsfFreeMechanicalBreakdownFeautureItemBool);
  const [checkedValue, setCheckedValue] = useState();
  const [optionalValue, setOptionalValue] = useState([]);
  const [selectedFeatureValue, setSelectedFeatureValue] = useState({
    featureGroupDesc: props.featureGroupDesc,
    featureGroupName: props.featureGroupName,
    featureItems: {
      featureItemsArray: [],
    },
  });
  const { i18n, t } = useTranslation();
	const currentLanguageCode = i18n.language || "en";

  useEffect(() => {
    setCheckedValue(null);
    setOptionalValue([]);
    const emptyFeatures = {
      featureGroupDesc: props.featureGroupDesc,
      featureGroupName: props.featureGroupName,
      featureItems: {
        featureItemsArray: [],
      },
    };
    setSelectedFeatureValue(emptyFeatures);
    props.onSelectFeatures(emptyFeatures);
  }, []);

  useEffect(() => {
    if (props.planChanged) {
      setCheckedValue();
      setOptionalValue([]);
      props.setPlanChanged && props.setPlanChanged(false);
    }
  }, [props?.planChanged]);

  const selectOptionFeature = (item) => {
    let options = [...optionalValue];
    const selectedFeature = { ...selectedFeatureValue };

    if (options.includes(item.featurecode)) {
      options = options.filter((i) => i != item.featurecode);
      setOptionalValue([...options]);
      selectedFeature.featureItems.featureItemsArray =
        selectedFeature?.featureItems?.featureItemsArray.filter(
          (i) => i.featurecode != item.featurecode
        );
      setSelectedFeatureValue({ ...selectedFeature });
    } else {
      options.push(item.featurecode);
      setOptionalValue([...options]);
      selectedFeature?.featureItems?.featureItemsArray.push(item);
      setSelectedFeatureValue({ ...selectedFeature });
    }
    props.onSelectFeatures(selectedFeatureValue);
  };

  const selectRadioFeature = (item, checkVal) => {
    const selectedFeature = { ...selectedFeatureValue };
    if (checkedValue !== item.featurecode || checkVal) {
      setCheckedValue(item.featurecode);
      const featuresArr = selectedFeature.featureItems.featureItemsArray.filter(
        (featureItm) => featureItm.featureControlType !== "E"
      );
      featuresArr.push(item);

      selectedFeature.featureItems.featureItemsArray = featuresArr;
      setSelectedFeatureValue({ ...selectedFeature });
    } else {
      setCheckedValue(null);
      selectedFeature.featureItems.featureItemsArray =
        selectedFeature.featureItems.featureItemsArray.filter(
          (i) => i.featurecode != item.featurecode
        );
      setSelectedFeatureValue({ ...selectedFeature });
    }
    props.onSelectFeatures(selectedFeatureValue);
  };

  const isRadio = (code) => {
    return code === "E";
  };

  const handleInputSwitch = (val) => {
    setActive(val);
    if (!val) {
      setCheckedValue(null);
      setOptionalValue([]);
      const emptyFeatures = {
        featureGroupDesc: props.featureGroupDesc,
        featureGroupName: props.featureGroupName,
        featureItems: {
          featureItemsArray: [],
        },
      };
      setSelectedFeatureValue(emptyFeatures);
      props.onSelectFeatures(emptyFeatures);
    }
  };

  const featureItems = props.featureItems?.featureItemsArray.map((item, i) => (
    <div key={"f_item_" + i} className="feature-item">
      <div className="field-radiobutton d-flex justify-content-between align-items-center w-100">
        <div className="d-flex align-items-center">
          {isRadio(item.featureControlType) ? (
            <RadioButton
              name={props.featureGroupName}
              value={item.featurecode}
              onChange={(e) => {
                selectRadioFeature(item, e.checked);
              }}
              checked={checkedValue === item.featurecode}
            />
          ) : (
            <Checkbox
              checked={optionalValue.includes(item.featurecode)}
              name={props.featureGroupName}
              value={item.featurecode}
              onChange={(e) => {
                selectOptionFeature(item);
              }}
            />
          )}

          <label className="mx-2 fm-bliss2-bold text-md">
            {currentLanguageCode === "ar"
              ? item.featureDescription || item.featurename
              : item.featurename}
          </label>
        </div>
        <div className="d-flex align-items-baseline">
          <h4 className="m-0 fm-lato mx-1">{item?.priceDetails?.priceDetailsArray[0]?.priceValue}</h4>
          <span>{t("policyDetails.SAR")}</span>
        </div>
      </div>
    </div>
  ));

  const bsfFreeGCCFeautureItem =
    bsfFreeGCCFeautureItemBool ? (
      <div className="feature-item">
        <div className="field-radiobutton d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center">
            <label className="mx-2 fm-bliss2-bold text-md">GCC Geographical Extension</label>
          </div>

          <div className="d-flex align-items-baseline">
            <h4 className="m-0 fm-lato mx-1 fw-bold">FREE</h4>
          </div>
        </div>
      </div>
    ) : null;

    const bsfFreeMechanicalBreakdownFeautureItem =
      bsfFreeMechanicalBreakdownFeautureItemBool ? (
      <div className="feature-item">
        <div className="field-radiobutton d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center">
            <label className="mx-2 fm-bliss2-bold text-md">Road Side Assistance</label>
          </div>

          <div className="d-flex align-items-baseline">
            <h4 className="m-0 fm-lato mx-1 fw-bold">FREE <span className="fw-light fs-6">(+ Free car maintenance trips to agency workshop)</span></h4>
          </div>
        </div>
      </div>
    ) : null;

  return (
    <StyleWrapper businessColor={props.businessColor || BUSINESS_LINE_COLORS.DEFAULT}>
      <div className="d-flex">
        <InputSwitch
          checked={active}
          onChange={(e) => {
            handleInputSwitch(e.value);
            props.onSelectFeatures(e.value ? selectedFeatureValue : null);
          }}
        />
        <div className="mx-3">
          <h5 className="fm-bliss2-bold">{props.featureGroupName}</h5>
          <p className="m-0">{props.featureGroupDesc}</p>
        </div>
      </div>
      {active && (
        <div className="items-section">
          <div className="feature-items">
            {[bsfFreeMechanicalBreakdownFeautureItem, bsfFreeGCCFeautureItem, ...featureItems]}

            {/* <div className="d-flex mt-4 mb-2">
              <InputSwitch
                checked={applyAll}
                onChange={(e) => setApplyAll(e.value)}
              />
              <p className="m-0 mx-2">{t("policyDetails.applyAllSelection")}</p>
            </div> */}
          </div>
        </div>
      )}
    </StyleWrapper>
  );
};

FeatureCard.propTypes = propTypes.exact({
  title: propTypes.string.isRequired,
  description: propTypes.string,
  items: propTypes.arrayOf(
    propTypes.exact({
      title: propTypes.string.isRequired,
      code: propTypes.string.isRequired,
      price: propTypes.string.isRequired,
      type: propTypes.oneOf(["E", "A"]).isRequired,
    })
  ),
}).isRequired;

export default FeatureCard;
